<template>
	<div>
		<a
			@click="showModal"
			class="btn btn-custom-create btn-info btn_color d-flex"
			style="
				color: white;
				padding-top: 4px;
				padding-bottom: 3px;
				width: 100%;
				padding-left: 25px;
				padding-right: 25px;
				justify-content: center;
				background: linear-gradient(90deg, #00a79d, #4dbc8e) !important;
			"
		>
			<span style="font-size: 12px; font-weight: bolder"
				>Opret notat</span
			>
		</a>
		<put-modal
			@close="
				state.isPutModal = false;
				$emit('close');
			"
			:store="authStore"
			v-if="state.isPutModal"
			:data="data"
			:state="state"
		>
		</put-modal>
	</div>
</template>

<script setup>
import { ref } from "vue";
import putModal from "../modals/putModal.vue";
import { useAuthStore } from "../../../../newSrc/stores/authStore";
const authStore = useAuthStore();

const props = defineProps({
	student: Number,
	journaltype: Number,
	headlineid: Number,
	theme: String,
	medicintreatmentid: Number,
});

const data = ref({
	studentId: props.student,
});

const state = ref({
	isPutModal: false,
});

const showModal = () => {
	if (props.journaltype
		&& props.headlineid
		&& props.theme
		&& props.medicintreatmentid
	) {
		data.value.note = {
			type: {
				id: props.journaltype,
			},
			headline_type: 'health terms headline',
			headline_id: props.headlineid,
			cat_id: props.theme,
			medicin_treatment_id: props.medicintreatmentid,
		}
	}

	state.value.isPutModal = true
};
</script>
<style>
@import url("/safejournal/frontend/public/css/app.css");
</style>
